import Swal from "sweetalert2";
// icons svg

export const SuccessSwal = (item: any) => {
  Swal.fire({
    imageAlt: "Custom image",
    animation: false,
    html: `<div style="display:flex;justify-content:center;align-items:center;gap:20px;padding:10px;flex-direction: column;"><span style="color: #0178c1;font-size:16px;font-weight:700">${item}</span>`,
    showConfirmButton: false,
    timer: 1800,
    width: 320,
  });
};

export const ErrorSwal = (err: any) => {
  Swal.fire({
    icon: "error",
    text: err,
    showConfirmButton: false,
    timer: 3000,
  });
};

export const WarningSwal = (text: any) => {
  Swal.fire({
    icon: "warning",
    text: text,
    showConfirmButton: false,
  });
};

export const WarningNetworkFailure = () => {
  Swal.fire({
    imageAlt: "Custom image",
    animation: false,
    html: `<div style="display:flex;justify-content:center;align-items:center;gap:20px;padding:10px;flex-direction: column;"><span style="color: #FF8A00;font-size:18px;font-weight:700">ເຄືອຄ່າຍຂັດຂ້ອງກະລຸນາເຊື່ອມອິນເຕີເນັດ!</span>`,
    showConfirmButton: false,
    width: 420,
  });
};

export const WarningError = (text: any) => {
  Swal.fire({
    imageAlt: "Custom image",
    animation: false,
    html: `<div style="display:flex;justify-content:center;align-items:center;gap:20px;padding:10px;flex-direction: column;"><span style="color: #FF0000;font-size:18px;font-weight:700">${text}</span>`,
    showConfirmButton: false,
    width: 420,
  });
};

export const wariningWithTextAndConfirmButton = (
  title: any,
  detail: any,
  onConfirm: any
) => {
  Swal.fire({
    title: title,
    text: detail,
    icon: "success",
    timer: 5000,
  }).then(async () => {
    try {
      await onConfirm();
    } catch (error: any) {
      console.log("Error: ", error);
    }
  });
};
